import Typography from '@/common/components/base/typography/Typography';
import ChartIcon from '@/modules/Statistics/assets/icons/chart2.svg?react';
import MedalStarIcon from '@/modules/Statistics/assets/icons/medal-star.svg?react';
import StarIcon from '@/modules/Statistics/assets/icons/star.svg?react';
import WarningIcon from '@/modules/Statistics/assets/icons/warning.svg?react';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';
import { getEvaluationSummaryQueryOptions } from '../../queries/getEvaluationSummary/getEvaluationSummaryQueryOptions';

type Props = {
  onSelect?: (id: number) => void;
};

export default function StatisticInfo({ onSelect }: Props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const { data } = useQuery(
    getEvaluationSummaryQueryOptions({ user_type: 'adjuster' }),
  );

  const stats = [
    {
      value: data?.national_rank ?? <MedalStarIcon />,
      label: 'رتبه کشوری',
      id: 1,
    },
    {
      value: data?.performance ?? <ChartIcon />,
      label: 'عملکرد',
      id: 2,
    },
    {
      value: data?.survey_total_score ?? <StarIcon />,
      label: 'رضایت',
      id: 3,
    },
    {
      value: data?.complaint ?? <WarningIcon />,
      label: 'شکایت',
      id: 4,
    },
  ];

  const handleItemClick = (index: number, id: number) => {
    setActiveIndex(index);
    onSelect?.(id);
  };

  return (
    <Box
      position="sticky"
      top="0"
      zIndex="layout"
      backgroundColor="white"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      padding="8px 16px"
      borderBottom="1px solid #F0F0F0"
      boxShadow="0 10px 15px -10px rgba(0, 0, 0, 0.04)"
      width={{ base: 'calc(100% + 32px)', xl: '100%' }}
      marginInline={{ base: '-16px', xl: '0' }}
    >
      {stats.map((item, index) => {
        const isActive = activeIndex === index;

        return (
          <Box
            key={item.id}
            onClick={() => handleItemClick(index, item.id)}
            cursor="pointer"
            flex="1"
            display="flex"
            flexDirection="column"
            gap="2px"
            alignItems="center"
            justifyContent="center"
            transition="all 0.2s"
            width="25%"
            padding="8px 0px"
            borderRadius="8px"
            bg={isActive ? 'purple-6' : 'transparent'}
          >
            <Typography
              textStyle="h1"
              textAlign="center"
              whiteSpace="nowrap"
              color={isActive ? 'purple-primary' : 'black-2'}
              fontWeight={isActive ? 'bold' : 'normal'}
              css={{
                '& svg path': {
                  fill: 'currentColor',
                },
              }}
            >
              {item.value}
            </Typography>
            <Typography
              textStyle="b2"
              whiteSpace="nowrap"
              color={isActive ? 'purple-primary' : 'black-2'}
              fontWeight={isActive ? 'bold' : 'normal'}
            >
              {item.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
